import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard {

  constructor(
    private router: Router,
    private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.signedIn) {
      return true;
    } else {
      this.authService.signIn()
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-guard.service.ts